/**
 * DISC Testi için skorları hesaplar.
 */
export function calculateDisc(questions, answers) {
    const scores = { D: 0, I: 0, S: 0, C: 0 };

    questions.forEach((q) => {
        const answerValue = answers[q.id];
        if (!answerValue) return;
        if (["D", "I", "S", "C"].includes(answerValue)) {
            scores[answerValue]++;
        } 
       
        else {
            
        }
    });
    return scores;
}

/**
 * OCEAN (Big Five) Testi Hesaplaması
 */
export function calculateOcean(questions, answers) {
    const scores = { O: 0, C: 0, E: 0, A: 0, N: 0 };

    questions.forEach((q) => {
        const val = answers[q.id];
        const point = parseInt(val, 10); 
        const categoryKey = q.factor || q.trait;

        if (categoryKey && !isNaN(point)) {
            const key = categoryKey.toUpperCase(); 
            
            if (scores.hasOwnProperty(key)) {
                scores[key] += point;
            }
        }
    });

    return scores;
}

/**
 * RIASEC Testi Hesaplaması
 */
export function calculateRiasec(questions, answers) {
    const scores = { R: 0, I: 0, A: 0, S: 0, E: 0, C: 0 };

    questions.forEach((q) => {
        const val = answers[q.id];
        const point = parseInt(val, 10);

        // DÜZELTME BURADA: q.trait YOKSA q.factor KULLAN
        const categoryKey = q.factor || q.trait;

        if (categoryKey && !isNaN(point)) {
            const key = categoryKey.toUpperCase();
            
            if (scores.hasOwnProperty(key)) {
                scores[key] += point;
            }
        }
    });

    return scores;
}